import { render, staticRenderFns } from "./SheBeiTaiShi.vue?vue&type=template&id=465f0045&scoped=true&"
import script from "./SheBeiTaiShi.vue?vue&type=script&lang=js&"
export * from "./SheBeiTaiShi.vue?vue&type=script&lang=js&"
import style0 from "./SheBeiTaiShi.vue?vue&type=style&index=0&id=465f0045&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f0045",
  null
  
)

export default component.exports